const typeTab = (() => {
  if (document.querySelector("body#pageType") !== null) {
    if (document.querySelector("div#jsTabWrap") !== null) {



      let tabWrap = document.querySelector('#jsTabWrap');
      let tabBoxs = tabWrap.querySelectorAll('.js-tab-box');

      let typeWraps = document.querySelectorAll('.js-type-wrap-outer');


      tabBoxs.forEach((element, index) => {

        element.addEventListener('click', () => {

          tabBoxs.forEach((element2, index2) => {
            tabBoxs[index2].classList.remove('is-act');
            typeWraps[index2].classList.remove('is-act');
          });

          tabBoxs[index].classList.add('is-act');
          typeWraps[index].classList.add('is-act');

        });

      });


      tabBoxs[0].classList.add('is-act');
      typeWraps[0].classList.add('is-act');



    }
  }
})()
export default typeTab;